import React from 'react';

export function MarkdownMark({
  text,
  variant = 'default',
}: {
  text: string;
  variant?: string;
}): React.JSX.Element {
  let style = 'bg-blue-500';
  if (variant === 'secondary') {
    style = 'bg-gray-800';
  }

  return (
    <mark className={`px-2 py-1 text-white ${style} rounded`}>{text}</mark>
  );
}
